// angular
import { Component, computed, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IAuction } from '@app/+auctions/shared/types/auctions.type';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-auction-lot-specs-tab',
  standalone: true,
  imports: [TranslateModule, TranslateDataPipe],
  templateUrl: './auction-lot-specs-tab.component.html',
  styleUrl: './auction-lot-specs-tab.component.scss',
})
export class AuctionLotSpecsTabComponent {
  auction = input.required<IAuction>();

  private readonly _translateData = inject(TranslateDataPipe);

  shipmentTermsLabel = computed(() => {
    const terms = this.auction()?.product?.shipment_terms;
    if (!terms?.length) {
      return '-';
    }
    return terms.join(' / ');
  });

  paymentTermsLabel = computed(() => {
    const methods = this.auction()?.product?.payment_methods;
    if (!methods?.length) {
      return '-';
    }
    return methods.join(' / ').toUpperCase();
  });

  deliveryCityLabel = computed(() => {
    const address =
      this._translateData.transform(this.auction()?.delivery_address) ||
      this._translateData.transform(this.auction()?.product?.delivery_address);

    return address || '-';
  });
}
